<template>
    <v-dialog fullscreen v-model="show" :width="width">
        <v-card>
            <v-toolbar align="center" flat dense>
                <v-btn small icon>
                    <v-icon small @click="show=false">mdi-close</v-icon>
                </v-btn>
                <v-spacer/>
                <v-card-subtitle style="font-size: 16px;font-weight: bold">选择图标</v-card-subtitle>
                <v-spacer/>

            </v-toolbar>
            <v-divider/>
            <v-card-text class="mt-4">
                <v-icon-selector @selectIcon="onSelectIcon"></v-icon-selector>
            </v-card-text>
            <!--            <v-card-actions>-->
            <!--                <v-spacer/>-->
            <!--                <v-btn tile color="primary" @click="onOk">确定</v-btn>-->
            <!--                <v-btn tile outlined @click="show=false">取消-->
            <!--                </v-btn>-->
            <!--            </v-card-actions>-->
        </v-card>
    </v-dialog>
</template>

<script>
    import _ from 'lodash';

    export default {
        name: "FormDialog",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            width: {
                type: Number,
                default: 600
            },
        },
        watch: {
            value(val) {
                this.show = this.value;
            }
        },
        created() {
            this.show = this.value;
        },
        data() {
            return {
                show: null,
                dataItem: {},
                formFields: [],
                formRows: []
            }
        },
        methods: {
            onOk() {
                this.formFields.forEach(x => {
                    this.dataItem[x.code] = x.value;
                })
                this.$emit('ok', this.dataItem);
            },
            onSelectIcon(icon) {
                console.log(icon);
                this.$emit('ok', icon);
            }
        }
    }
</script>

<style scoped>

</style>